export enum ButtonType {
	PRIMARY = 'primary',
	FILTER = 'filter',
	TAB = 'tab',
	NAV = 'nav',
	LINK = 'link',
}
